export const getErrorTranslationTemplate = (errorTemplate: string) => {
  const data = errorTemplate.split(/\|(.*)/);
  const key = data[0];
  const template =
    data[1]?.split(/;(?=\w+)/).reduce<Record<string, string>>((obj, param) => {
      const kv = param.split(/:(.*)/);
      obj[kv[0]] = kv[1];
      return obj;
    }, {}) ?? {};
  return { key, template };
};
